import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DoctorSidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/doctor/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/doctor/appointments', label: 'Appointments', icon: '📅' },
    { path: '/doctor/services', label: 'Services', icon: '💼' },
    { path: '/doctor/availability', label: 'Availability', icon: '⏰' },
    { path: '/doctor/locations', label: 'Locations', icon: '📍' },
    { path: '/doctor/reviews', label: 'Reviews', icon: '⭐' },
    { path: '/doctor/payments', label: 'Payments', icon: '💳' },
    { path: '/doctor/embed', label: 'Embed Widget', icon: '🔗' },
    { path: '/doctor/link-in-bio', label: 'Link in Bio', icon: '🌐' },
    { path: '/doctor/cancellation-policy', label: 'Cancellation Policy', icon: '📋' },
    { path: '/doctor/settings', label: 'Settings', icon: '⚙️' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <aside className="w-64 bg-white dark:bg-charcoal border-r border-light-border dark:border-border min-h-screen sticky top-0">
      <nav className="p-4 space-y-1">
        <div className="mb-6 px-3">
          <h2 className="font-display text-xl italic text-light-text dark:text-silver">
            Doctor Portal
          </h2>
        </div>
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`
              flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors
              font-mono text-sm
              ${
                isActive(item.path)
                  ? 'bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary font-medium'
                  : 'text-light-text-secondary dark:text-silver/70 hover:bg-light-border/50 dark:hover:bg-border/50'
              }
            `}
          >
            <span className="text-lg">{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default DoctorSidebar;
